import { Box, Button, Autocomplete, TextField } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { FormProvider } from "src/components/hook-form";
import RHFDatePicker from "src/components/hook-form/RHFDatePicker";
import Users from "src/components/users";
import useLocales from "src/hooks/useLocales";
import useProductList from "src/components/ProductAutoComplete/hooks/useProductList";

const defaultValues = {
  start_date: "",
  end_date: "",
  user_id: "",
  product_id: "",
};

const Filter = ({ setFilter }) => {
  const methods = useForm({ defaultValues });
  const { translate } = useLocales();
  const productList = useProductList(false);
  const onSubmit = (data) => {
    setFilter(data);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1,1fr)",
            sm: "repeat(5, 1fr)",
          },
          rowGap: 3,
          columnGap: 3,
          marginBottom: "2rem",
        }}
      >
        <RHFDatePicker
          label={translate("adminFinancial.payout.pickStartDate")}
          name="start_date"
          size="small"
        />
        <RHFDatePicker
          label={translate("adminFinancial.payout.pickEndDate")}
          name="end_date"
          size="small"
        />
        <Users
          name="user_id"
          label={translate("adminStore.businessBuilder.userName")}
          size="small"
        />
        <Controller
          name="product_id"
          control={methods.control}
          render={({ field }) => (
            <Autocomplete
              options={productList}
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(_, value) => field.onChange(value?.id || "")}
              value={productList.find((p) => p.id === field.value) || null}
              size="small"
              renderInput={(params) => (
                <TextField {...params} label="Product" />
              )}
            />
          )}
        />
        <Button type="submit" variant="contained" size="medium">
          Get Report
        </Button>
      </Box>
    </FormProvider>
  );
};

export default Filter;
